module.exports = __webpack_public_path__ + "media/snake.8a74fa53.wav";